var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageActiveBackup = function SvgMessageActiveBackup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#26BAB9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M8.292 17.417h-.458c-3.667 0-5.5-.917-5.5-5.5V7.333q0-5.5 5.5-5.5h7.333q5.5 0 5.5 5.5v4.584q0 5.5-5.5 5.5h-.458a.93.93 0 0 0-.734.366L12.6 19.617c-.605.806-1.595.806-2.2 0l-1.375-1.834c-.146-.201-.486-.366-.733-.366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#26BAB9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.163 10.083h.008M11.496 10.083h.008M7.828 10.083h.009"
  })));
};
export default SvgMessageActiveBackup;